import PropertyCard from "./PropertyCard";

export default PropertyCard;
